import { getTokenWeights } from '@helpers/vaults/vault.helpers';

import { toBN } from '@utils/formaters.utils';

import {
  PositionManagerInfoAerodromeType,
  PositionManagerInfoType,
} from '@dto/contracts/vaults/liquidityHelperV3.dto';
import { TokensDto } from '@dto/vaults/tokens.dto';
import { VaultFactoryDto } from '@dto/vaults/vault-factory.dto';

import { PositionManagerInfoItem } from '@app-types/vaults/positionManagerInfo.types';
import { PendingRewardsType } from '@app-types/vaults/vault.types';

type normalizePositionManagerInfoParamType = {
  tokens: TokensDto;
  vaultFactory: VaultFactoryDto;
  positionManagerInfo:
    | PositionManagerInfoType
    | PositionManagerInfoAerodromeType;
  tokenId: bigint;
};
export const normalizePositionManagerInfo = ({
  tokens,
  vaultFactory,
  positionManagerInfo,
  tokenId,
}: normalizePositionManagerInfoParamType): PositionManagerInfoItem => {
  const {
    owed0,
    owed1,
    unclaimedFee0,
    unclaimedFee1,
    tickIn,
    amount0,
    amount1,
    fee,
    lowPrice,
    upPrice,
    currentPrice,
    pool,
  } = positionManagerInfo;

  const token0 =
    tokens.poolv3[vaultFactory.chainId][
      positionManagerInfo.token0.toLowerCase()
    ];
  const token1 =
    tokens.poolv3[vaultFactory.chainId][
      positionManagerInfo.token1.toLowerCase()
    ];

  const {
    token1Weight,
    token0Weight,
    balance0,
    balance1,
    amount0Usd,
    amount1Usd,
    sumAmountUsd,
  } = getTokenWeights({
    token0,
    token1,
    amount0,
    amount1,
  });

  const feeToken0 = toBN(owed0 || 0, token0.decimals).plus(
    toBN(unclaimedFee0 || 0, token0.decimals),
  );
  const feeToken1 = toBN(owed1 || 0, token1.decimals).plus(
    toBN(unclaimedFee1 || 0, token1.decimals),
  );

  const fee0PendingRewards: PendingRewardsType = {
    pendingRewardsUsd: feeToken0.times(token0?.priceInUsd || 0),
    pendingRewards: feeToken0,
    rewardToken: token0,
  };

  const fee1PendingRewards: PendingRewardsType = {
    pendingRewardsUsd: feeToken1.times(token1?.priceInUsd || 0),
    pendingRewards: feeToken1,
    rewardToken: token1,
  };

  const unclaimedFees = fee0PendingRewards.pendingRewardsUsd.plus(
    fee1PendingRewards.pendingRewardsUsd,
  );

  const _lowPrice = toBN(lowPrice, token1.decimals);
  const _upPrice = toBN(upPrice, token1.decimals);
  const _currentPrice = toBN(currentPrice, token1.decimals);

  return {
    feePendingRewards: [fee0PendingRewards, fee1PendingRewards],
    token0Weight,
    token1Weight,
    tickIn,
    token0,
    token1,
    amount0: balance0,
    amount1: balance1,
    amount0Usd,
    amount1Usd,
    liquidity: sumAmountUsd,
    unclaimedFees,
    lowPrice: _lowPrice,
    upPrice: _upPrice,
    currentPrice: _currentPrice,
    poolV3Fee: fee / 1000000,
    tokenId: Number(tokenId),
    chainId: vaultFactory.chainId,
    pool,
  };
};
